import { useRef } from 'react';

export const useCache = <V = any>(initialValue: Record<string, V> = {}) => {
  const ref = useRef(initialValue);
  return ref.current;
};
